import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from 'react-hook-form';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs/selectors';

import { Select } from '../Select';

interface EmploymentBusinessCategorySelectionProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label?: string;
}
export const EmploymentBusinessCategorySelection = <T extends FieldValues>({
  name,
  control,
  label,
}: EmploymentBusinessCategorySelectionProps<T>) => {
  const { t } = useTranslate();
  const { businessCategories } = useAppSelector(selectConfigsState);

  const {
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <Select
      options={businessCategories}
      control={control}
      name={name}
      error={!!error}
      helperText={error?.message}
      rules={{
        required: t('employerForm.form.businessCategory.required'),
      }}
      fullWidth
      label={label}
      placeholder={t('employerForm.form.businessCategory.placeholder')}
      useDrawerOnMobile
      withSearchBar
    />
  );
};
